// Logs activity to the db, whatever it is (user/garden/plant, watering/fertilizing, e.t.c)
// if someone is looking at this code in the future, good luck seriously!

export async function addNewActivity(
    actor,
    subject,
    subject_id,
    action,
    value = null,
    unit = null,
    old_status = null,
    new_status = null,
    notes = null
) {
    const eventDetails = {
        actor,
        subject,
        subject_id,
        action,
        value,
        unit,
        old_status,
        new_status,
        notes,
    };

    try {
        const response = await fetch('/api/activities/addGardenEvent', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ eventDetails }),
        });

        if (!response.ok) {
            throw new Error(`Failed to log activity: ${response.statusText}`);
        }

        return await response.json(); // could return created event object
    } catch (error) {
        console.error('Error adding new activity:', error);
        throw error;
    }
}
